export const NAV_ITEMS = [
  { id: "menu", label: "Lunch & Dinner Menu" },
  { id: "blog", label: "Blog" },
  { id: "about", label: "About Us" },
  { id: "contact", label: "Contact" },
];
